export const TYPE_OPTIONS = [
  {
    label: '标准流程&文件',
    value: 0
  },
  {
    label: '操作指引',
    value: 1
  },
  {
    label: '系统公告',
    value: 2
  },
  {
    label: '避坑指南',
    value: 3
  },
  {
    label: '培训文档',
    value: 4
  }
]
export const TIME_OPTIONS = [
  {
    label: '永久',
    value: 0
  },
  {
    label: '时间范围',
    value: 1
  }
]
export const BOOL_OPTIONS = [
  {
    label: '是',
    value: 1
  },
  {
    label: '否',
    value: 0
  }
]
export const RULES = {
  type: [
    {
      required: true,
      message: '请选择类型',
      type: 'number'
    }
  ],
  effectiveType: [
    {
      required: true,
      message: '请选择有效时间',
      type: 'number'
    }
  ],
  isMandatory: [
    {
      required: true,
      message: '请选择是否强制弹窗',
      type: 'number'
    }
  ],
  popupTime: [
    {
      required: true,
      message: '请输入限制弹窗时长',
      type: 'number'
    }
  ],
  isDownloadAllowed: [
    {
      required: true,
      message: '请选择是否允许下载',
      type: 'number'
    }
  ],
  releaseScopeArr: [
    {
      required: true,
      message: '请选择发布范围',
      type: 'array'
    }
  ],
  title: [
    {
      required: true,
      message: '请填写标题'
    }
  ],
  content: [
    {
      required: true,
      message: '请填写具体内容'
    }
  ],
  belongDepartment: [
    {
      required: true,
      message: '请选择归属部门',
      type: 'number'
    }
  ]
}
export const NOTICE_INFO_COLUMNS = [
  {
    title: '分类',
    dataIndex: 'category',
    key: 'category',
    width: '100px'
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '归属部门',
    dataIndex: 'belongDepartmentStr',
    key: 'belongDepartmentStr',
    width: '100px'
  },
  {
    title: '商品大类',
    dataIndex: 'goodsMajorCategoryStr',
    key: 'goodsMajorCategoryStr',
    width: '100px'
  },
  {
    title: '关键词',
    dataIndex: 'keyword',
    key: 'keyword',
    width: '100px'
  },

  {
    title: '有效时间',
    dataIndex: 'effectiveTimeStr',
    key: 'effectiveTimeStr'
  },
  {
    dataIndex: 'isReadStr',
    key: 'isReadStr',
    customeTitle: '是否已读',
    notes: '必须点击【已阅读】按钮后，状态变更已读',
    width: '100px'
  },

  {
    title: '发布人',
    dataIndex: 'announceUserName',
    key: 'announceUserName'
  },
  {
    title: '发布时间',
    dataIndex: 'announceTimeStr',
    key: 'announceTimeStr'
  },
  // {
  //   title: '修改人',
  //   dataIndex: 'modifierName',
  //   key: 'modifierName'
  // },
  // {
  //   title: '修改时间',
  //   dataIndex: 'gmtModifiedStr',
  //   key: 'gmtModifiedStr'
  // },
  {
    title: '操作',
    dataIndex: '',
    key: 'action'
  }
]
